<template>
  <v-card elevation="0">
    <v-card-actions
      class="pa-1 bg-red"
      :class="trade_card.is_real ? 'real-trade-color' : 'virtual-trade-color'"
    >
      <div v-if="trade_card.is_real">REAL TRADE</div>
      <div v-else>VIRTUAL TRADE</div>
    </v-card-actions>
    <v-card-title
      :class="!$vuetify.breakpoint.xsOnly ? 'pa-6 pb-3' : 'pa-5 pb-2'"
    >
      <!-- {{ $route.name }} -->
      <v-row class="justify-space-between">
        <v-col
          cols="9"
          md="7"
          class="pr-0"
          :class="$vuetify.breakpoint.xsOnly ? 'pb-0' : ''"
        >
          <div>
            <div class="d-flex">
              <div class="brand-bg">
                <v-img
                  v-if="trade_card.security_logo"
                  class="brand-logo"
                  contain
                  :src="trade_card.security_logo"
                ></v-img>
                <v-img style="opacity: 60%" v-else :src="noImage_logo"> </v-img>
              </div>
              <div class="card-titles ml-3">
                <div>
                  <div class="brand-name">
                    <span
                      @click="routeToSearchPage(trade_card)"
                      style="cursor: pointer"
                    >
                      {{ trade_card.security_symbol }}</span
                    >
                    <div style="display: none">
                      <!-- WATCHLIST MENUUUU -->
                      <watchlist-menu> </watchlist-menu>
                    </div>
                    <v-menu rounded="lg" offset-y>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="security-bookmark"
                          icon
                          @click="getWatchlistTabs('stock')"
                          :loading="security_bookmark_loading"
                        >
                          <!-- have to handel the follower in the future, currently we didn't get the is_follower cause we have multiple watchlist now -->
                          <!-- v-if="!trade_card.is_follower_security" -->
                          <v-icon
                            :small="$vuetify.breakpoint.xsOnly"
                            color="#2d8cff"
                            v-if="
                              trade_card.is_security_saved ||
                              securityBookmarkActive
                            "
                          >
                            mdi-bookmark
                          </v-icon>
                          <v-icon
                            v-else
                            :small="$vuetify.breakpoint.xsOnly"
                            color="#333333"
                            >mdi-bookmark-outline</v-icon
                          >
                        </v-btn>
                      </template>
                      <!-- <v-progress-circular
                        v-if="bookmark_loading"
                        :size="20"
                        color="primary"
                        indeterminate
                      ></v-progress-circular> -->
                      <v-list>
                        <!-- {{ security_bookmark_loading }} -->

                        <v-list-item
                          @click="
                            addOrRemoveWatchlist(item, 'stock', trade_card)
                          "
                          v-for="item in watchlistTabs"
                          :key="item"
                          link
                        >
                          <v-list-item-title>
                            <!-- v-if="security_bookmark_loading" -->
                            <div>
                              {{ item.name }}
                            </div>
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </div>
                <div class="d-flex brand-subtitle">
                  <div>
                    {{ trade_card.security_name }} -
                    {{ trade_card.security_exchange }}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!$vuetify.breakpoint.xsOnly" class="card-live">
              <span
                :class="
                  trade_card.trade_type == 'Sell'
                    ? 'red--text'
                    : 'primary--text'
                "
                class="card-live-txt"
                >{{ trade_card.trade_type }}</span
              >
              <span> @{{ trade_card.entry_price }} </span> <span> ● </span>
              <span class="text-capitalize"> {{ trade_card.lots }} Qty </span>
              <span>●</span>
              <span class="text-capitalize">
                {{ trade_card.duration_name }}</span
              >
              <v-icon v-if="trade_card.is_trade_private" small color="grey"
                >mdi-lock</v-icon
              >
              <v-icon
                class="ml-2"
                v-else-if="trade_card.posted_by_group"
                small
                color="grey"
                >mdi-account-group</v-icon
              >
              <v-icon :small="$vuetify.breakpoint.xsOnly" v-else color="grey"
                >mdi-earth</v-icon
              >
            </div>
          </div>
        </v-col>
        <!-- {{ $route.name }} -->
        <v-col
          cols="3"
          md="5"
          :lg="
            $route.name == 'ProfilePage' || $route.name == 'Search' ? 3 : '5'
          "
          class="pl-0"
          :class="$vuetify.breakpoint.xsOnly ? 'pr-0' : ''"
        >
          <v-col v-if="!$vuetify.breakpoint.xsOnly">
            <ToolTipTradeStatus :trade_card="trade_card"> </ToolTipTradeStatus>
          </v-col>
          <div v-else class="d-flex align-center flex-column">
            <div class="d-flex">
              <v-tooltip
                content-class="tooltip"
                color="#F7FAFF"
                bottom
                max-width="300"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-bind="attrs"
                    v-on="on"
                    :class="tradeCardStatus(trade_card.status)"
                  >
                    ● {{ tradeCardStatus(trade_card.status) }}
                  </div>
                </template>
                <span class="tooltip-text">{{ statusContent }}</span>
              </v-tooltip>

              <v-tooltip
                v-if="trade_card.status != 'Inactive'"
                content-class="tooltip-status"
                min-width="200px"
                color="#fff"
                bottom
                style="
                  box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px,
                    rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;
                  padding: 3px;
                  height: 200px;
                  background: #fff;
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="ml-1" small v-bind="attrs" v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                <!-- <v-card class="px-0" min-height="40px"> -->
                <div
                  slot=""
                  style="background-color: #fff"
                  class="tooltip-content-wrapper"
                >
                  <!-- <v-col> -->
                  <ToolTipTradeStatus :trade_card="trade_card">
                  </ToolTipTradeStatus>
                  <!-- </v-col> -->
                </div>
                <!-- </v-card> -->
              </v-tooltip>
            </div>
            <div class="time">
              <span> {{ getTime(trade_card.created) }} </span>
            </div>
          </div>
          <div
            v-if="!$vuetify.breakpoint.xsOnly"
            class="d-flex justify-end mt-2 mr-12"
          >
            <div
              v-if="!$vuetify.breakpoint.xsOnly && trade_card.copy_origin_name"
            >
              <span class="trade-origin">Trade Origin </span>
              <span class="origin-name">
                {{ trade_card.copy_origin_name }}
              </span>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card-title>
    <div v-if="$vuetify.breakpoint.xsOnly" class="card-live pl-5">
      <span
        :class="trade_card.trade_type == 'Sell' ? 'red--text' : 'primary--text'"
        class="card-live-txt"
        >{{ trade_card.trade_type }}</span
      >
      <span> @{{ trade_card.entry_price }} </span> <span> ● </span>
      <span class="text-capitalize"> {{ trade_card.lots }} Qty </span>
      <span>●</span>
      <span class="text-capitalize"> {{ trade_card.duration_name }}</span>
      <v-icon v-if="trade_card.is_trade_private" small color="grey"
        >mdi-lock</v-icon
      >
      <v-icon
        class="ml-2 mt-1"
        v-else-if="trade_card.posted_by_group"
        small
        color="grey"
        >mdi-account-group</v-icon
      >
      <v-icon class="" :small="$vuetify.breakpoint.xsOnly" v-else color="grey"
        >mdi-earth</v-icon
      >
    </div>
    <div
      v-if="$vuetify.breakpoint.xsOnly && trade_card.copy_origin_name"
      class="d-flex justify-start pl-5"
    >
      <div>
        <span class="trade-origin">Trade Origin </span>
        <span class="origin-name">
          {{ trade_card.copy_origin_name }}
          <!-- Sagar Patel -->
        </span>
      </div>
    </div>

    <v-divider> </v-divider>
    <v-card-text class="px-6">
      <!-- Sagar Trailing line code 👇 -->
      <TargetTrailing :trade_data="trade_data" :ref_append="ref_append">
      </TargetTrailing>
      <!-- Varun Trailing line code 👇 -->
      <!-- <target-trailing-two :trade_data="trade_data" :ref_append="ref_append">
      </target-trailing-two> -->
    </v-card-text>
    <v-card-text class="mt-1 px-7">
      <v-row :style="$vuetify.breakpoint.xsOnly ? 'align-items: baseline' : ''">
        <v-col
          :class="$vuetify.breakpoint.xsOnly ? 'pl-0 pt-0 flex-column' : ''"
          class="d-flex align-baseline"
          md="6"
          sm="6"
        >
          <div
            class="live-current-price-label d-flex align-baseline flex-row mr-2"
          >
            <div :class="$vuetify.breakpoint.xsOnly ? 'mr-1' : ''">
              <span v-if="trade_data.status != 'Closed'">
                {{ !trade_data.trade_exit_type ? "Live Price" : "Exit Price" }}
              </span>
              <span v-else> Exit Price </span>
            </div>

            <!-- <v-tooltip v-if="$vuetify.breakpoint.xsOnly" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="" x-small v-bind="attrs" v-on="on">
                  mdi-information-outline
                </v-icon>
              </template>
              <span>Live Price</span>
            </v-tooltip> -->
          </div>
          <div
            :style="$vuetify.breakpoint.xsOnly ? 'white-space: nowrap' : ''"
            class="live-current-price"
          >
            <span
              v-if="trade_data.status == 'Closed' || trade_data.trade_exit_type"
            >
              ₹{{ trade_data.exit_price.toFixed(2) }}
            </span>
            <span v-else> ₹{{ trade_data.live_price }} </span>
            <span
              :class="
                trade_data.price_up_down < 0
                  ? 'negative-live-price'
                  : 'positive-live-price'
              "
              class="live-price-percentage"
            >
              <v-icon
                v-if="
                  trade_data.price_up_down >= 0 && trade_data.status != 'Closed'
                "
                class="pb-1 mb-1"
                color="green"
                :small="$vuetify.breakpoint.xsOnly"
              >
                mdi-arrow-up
              </v-icon>
              <v-icon
                v-if="
                  trade_data.price_up_down < 0 && trade_data.status != 'Closed'
                "
                class="pb-1 mb-1"
                color="red"
                :small="$vuetify.breakpoint.xsOnly"
              >
                mdi-arrow-down
              </v-icon>
              {{ removeNegativeSign(trade_data.price_up_down) }} ({{
                trade_data.profit_percent
              }}%)</span
            >
            <span v-if="trade_data.trade_exit_type" class="manual-exit">
              Manual Exit
            </span>
          </div>
        </v-col>
        <v-col
          :class="
            !$vuetify.breakpoint.xsOnly
              ? 'align-baseline'
              : 'py-0 pl-0 flex-column align-end'
          "
          class="d-flex justify-end"
          md="6"
          sm="6"
        >
          <div :class="!$vuetify.breakpoint.xsOnly ? 'd-flex' : ''">
            <div
              :class="$vuetify.breakpoint.xsOnly ? 'mr-0' : 'mr-2'"
              class="live-current-price-label d-flex"
            >
              <div>
                {{ changeCurrentToolTip.name }}
              </div>
              <div
                :style="$vuetify.breakpoint.xsOnly ? 'margin-top: -2px' : ''"
              >
                <v-tooltip
                  bottom
                  content-class="tooltip"
                  color="#F7FAFF"
                  max-width="260"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      @click="currentPLTooltip = true"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <span class="tooltip-text">{{
                    changeCurrentToolTip.content
                  }}</span>
                </v-tooltip>
              </div>
            </div>
            <div
              :class="
                trade_data.pl_data < 0
                  ? 'negative-currentPL-price'
                  : 'positive-currentPL-price'
              "
              class="live-current-percentage text-end"
            >
              {{ removeNegativeSign(trade_data.pl_data) }} ({{
                trade_data.pl_percent
              }}%)
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider> </v-divider>
    <v-card-text class="px-1 py-0" v-if="trade_card.reasoning.content">
      <v-card-text
        class="reasoning-content"
        v-if="trade_card.reasoning.content.length >= 85"
      >
        <div v-if="!desMore">
          {{ trade_card.reasoning.content.substring(0, 85) }}...
          <span
            class="show_more"
            @click="(desMore = !desMore), readMoreEvents()"
            >Read more</span
          >
        </div>
        <div v-else>
          <!-- {{ trade_card.reasoning.content }} -->
          <div v-html="formattedText"></div>
          <span class="show_more" @click="desMore = !desMore">Read less</span>
        </div>
      </v-card-text>
      <v-card-text class="reasoning-content" v-else>
        <!-- {{ trade_card.reasoning.content }} -->
        <div v-html="formattedText"></div>
      </v-card-text>
    </v-card-text>
    <v-divider> </v-divider>
    <v-card-actions class="px-1 justify-space-between card-actions">
      <div class="d-flex align-center">
        <div>
          <!-- <v-avatar>
            <v-img :src="trade_card.user_image"> </v-img>
          </v-avatar> -->
          <v-avatar v-if="!trade_card.user_image" color="#f5f5f5">
            <div class="user-image">
              {{ getCharacter(trade_card.posted_by_name) }}
            </div>
          </v-avatar>
          <v-avatar v-else>
            <div class="user-image">
              <v-img class="users-img" :src="trade_card.user_image"> </v-img>
            </div>
          </v-avatar>
        </div>
        <div :class="$vuetify.breakpoint.xsOnly ? 'ml-2' : 'ml-4'">
          <div class="d-flex mb-2 align-center">
            <div
              v-if="trade_card.posted_by_group"
              class="card-user-name"
              @click="
                goToGroup(
                  trade_card.posted_by_group.id,
                  trade_card.posted_by_group
                )
              "
            >
              {{ removeLastName(trade_card.posted_by_group.name) }}
              <v-icon
                class="ml-2"
                small
                :x-small="$vuetify.breakpoint.xsOnly"
                color="grey"
                >mdi-account-group</v-icon
              >
            </div>
            <div
              @click="goToProfile($event, trade_data.posted_by_name)"
              v-else
              class="card-user-name"
            >
              <!-- {{ trade_card.posted_by_name }} -->
              {{ removeLastName(trade_card.posted_by_name) }}
            </div>
            <v-img
              v-if="trade_card.is_sebi_registered"
              class="ml-2"
              :src="verified"
              width="1.125rem"
              height="1.125rem"
            ></v-img>
          </div>
          <!-- <div v-if="!trade_card.posted_by_group" class="mt-2">
            <v-img class="dots-group" :src="dotsGroup"></v-img>
          </div> -->
        </div>
      </div>

      <div :class="$vuetify.breakpoint.xsOnly ? 'd-flex' : ''">
        <v-btn
          @click="deleteTrade"
          :small="$vuetify.breakpoint.xsOnly"
          v-if="isTradeUpcoming && is_same_user"
          class="mx-1 share"
          elevation="0"
        >
          <v-icon :small="$vuetify.breakpoint.xsOnly" color="0f0f0f"
            >mdi-trash-can-outline</v-icon
          >
        </v-btn>
        <v-menu v-if="!is_same_user" rounded="lg" offset-y>
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              @click="getWatchlistTabs('trade')"
              :loading="bookmark_loading"
              v-bind="attrs"
              v-on="on"
              class="mx-1 share"
              elevation="0"
              :small="$vuetify.breakpoint.xsOnly"
            >
              <v-icon
                :small="$vuetify.breakpoint.xsOnly"
                v-if="trade_card.is_trade_saved || tradeBookmarkActive"
                color="#2d8cff"
                >mdi-bookmark</v-icon
              >
              <v-icon v-else :small="$vuetify.breakpoint.xsOnly" color="#333333"
                >mdi-bookmark-outline</v-icon
              >
            </v-btn>
          </template>
          <!-- <v-progress-circular
            v-if="security_bookmark_loading"
            :size="20"
            color="primary"
            indeterminate
          ></v-progress-circular> -->
          <v-list>
            <!-- {{ security_bookmark_loading }} -->

            <v-list-item v-for="item in watchlistTabs" :key="item" link>
              <v-list-item-title
                @click="addOrRemoveWatchlist(item, 'trade', trade_card)"
              >
                <!-- v-if="security_bookmark_loading" -->

                <div>
                  {{ item.name }}
                </div>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          elevation="0"
          class="mx-1 share"
          style="margin-top: -2px"
          v-if="trade_card.report != null"
          :small="$vuetify.breakpoint.xsOnly"
          :loading="featuredBtnLoader"
          @click="downloadReport(trade_data)"
        >
          <v-icon :small="$vuetify.breakpoint.xsOnly" color="0f0f0f"
            >mdi-file-download-outline</v-icon
          >
        </v-btn>
        <v-btn
          elevation="0"
          class="mx-1 share"
          style="margin-top: -2px"
          v-if="is_same_user"
          :small="$vuetify.breakpoint.xsOnly"
          :loading="featuredBtnLoader"
          @click="addOrRemoveToFeatured(trade_data)"
        >
          <v-icon
            color="#F2C94C"
            :small="$vuetify.breakpoint.xsOnly"
            v-if="trade_data.is_featured"
            >mdi-star</v-icon
          >
          <v-icon :small="$vuetify.breakpoint.xsOnly" color="0f0f0f" v-else
            >mdi-star-outline</v-icon
          >
        </v-btn>
        <v-btn
          @click="
            shareTrade(
              trade_card.id,
              trade_card.posted_by_name,
              trade_card.trade_type,
              trade_card.security_name,
              trade_card.posted_by_id,
              trade_card.is_equity_trade
            )
          "
          :small="$vuetify.breakpoint.xsOnly"
          class="mx-1 share"
          elevation="0"
        >
          <v-icon :small="$vuetify.breakpoint.xsOnly" color="0f0f0f"
            >mdi-share-variant-outline</v-icon
          >
        </v-btn>
        <v-badge
          class="mr-2"
          v-if="trade_card.comments_count"
          bordered
          color="error"
          :content="trade_card.comments_count"
          overlap
        >
          <v-btn
            :small="$vuetify.breakpoint.xsOnly"
            @click="openComment()"
            class="mx-1 share"
            elevation="0"
          >
            <v-icon :small="$vuetify.breakpoint.xsOnly" color="0f0f0f"
              >mdi-comment-multiple-outline</v-icon
            >
          </v-btn>
        </v-badge>
        <v-btn
          :small="$vuetify.breakpoint.xsOnly"
          v-else
          @click="openComment()"
          class="mx-1 share"
          elevation="0"
        >
          <v-icon :small="$vuetify.breakpoint.xsOnly" color="0f0f0f"
            >mdi-comment-multiple-outline</v-icon
          >
        </v-btn>
        <v-btn
          v-if="isTradeLive && is_same_user"
          class="other-btn ml-1 mr-2"
          color="primary"
          elevation="0"
          :loading="exitBtnLoader"
          @click="exitTradeHandler(trade_data)"
        >
          Exit Trade
        </v-btn>
        <v-btn
          v-else-if="isTradeUpcoming && is_same_user"
          class="other-btn ml-1 mr-2"
          color="primary"
          elevation="0"
          @click="modifyTrade(trade_data.id)"
        >
          Modify Trade
        </v-btn>
        <!-- <v-btn
          v-else-if="is_posted_by_user"
          class="other-btn ml-1 mr-2"
          color="primary"
          elevation="0"
          @click="viewTrade('trade_detail_comment')"
        >
          View Trade
        </v-btn> -->
        <v-btn
          v-else
          class="trade-btn ml-1 mr-1"
          color="primary"
          style="border-radius: 5px"
          elevation="0"
          @click="copyTrade(trade_card)"
        >
          Trade
        </v-btn>
      </div>
    </v-card-actions>
    <v-expansion-panels v-model="comment">
      <v-expansion-panel>
        <v-expansion-panel-content class="comment-panel">
          <!-- <v-expansion-panel-header> </v-expansion-panel-header> -->
          <CommentsCard
            @close-comment="closeComment"
            @count-comment="countComment"
            :trade_detail_form="trade_card"
          >
          </CommentsCard>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <confirm-trade-delete-form :delete_data="delete_data">
    </confirm-trade-delete-form>
  </v-card>
</template>

<script>
import TargetTrailing from "./TargetTrailing.vue";
// import TargetTrailingTwo from "./TargetTrailingTwo.vue";
import commonFunctions from "@/common/commonFunctions.js";
import apiUrl from "@/common/apiUrl";
import Axios from "@/api/BaseAxios.js";
import newAxios from "@/api/newAxios";
import helper from "@/helper";
import CommentsCard from "@/components/OpenCommentPanel.vue";
import { isAuthenticated } from "@/common/commonFunctions.js";
import { mapActions } from "vuex";

// import ROUTER_URL from "@/constant/urls";
// import routingHandler from "@/constant/routingHandler";

import dayjs from "dayjs";
import ToolTipTradeStatus from "@/components/ToolTipTradeStatus.vue";
export default {
  // inject: ["trade_data", "ref"],
  // props: ["trade_data"],

  props: {
    ref_append: {
      default: "suffix",
      type: String,
    },
    trade_data: {},
  },

  name: "TradeCard",
  components: {
    TargetTrailing,
    // TargetTrailingTwo,
    CommentsCard,
    ToolTipTradeStatus,
    "confirm-trade-delete-form": () =>
      import("@/components/Trade/ConfirmTradeDeleteForm.vue"),
    "watchlist-menu": () =>
      import(
        "@/components/Profile/ProfileTradeDetails/Wacthlist/WatchlistMenu.vue"
      ),
  },
  data() {
    return {
      trade_card: this.trade_data,
      test_string:
        "Lorem ipsum dolor sit amet, consectetur aLorem ipsum dolor sit amet, consecteteren, Lorem ipsum is placeholder text commonly used in the graphic, print, and publishing industries for previewing layouts and visual mockups. Lorem Ipsum Generator.",
      desMore: false,
      dotsGroup: require("../assets/images/dotGroup.svg"),
      verified: require("../assets/images/gold_check.svg"),
      noImage_logo: require("@/assets/images/No-img-logo.svg"),
      bookmark_loading: false,
      security_bookmark_loading: false,
      comment: null,
      currentPLTooltip: false,
      loggedInProfile: {},
      profile_object: {},
      exitBtnLoader: false,
      watchlistLoader: false,
      featuredBtnLoader: false,
      watchlistTabs: [],
      delete_data: {
        flag: false,
        id: null,
      },
      is_trade_exit: false,
      plToolTipContent: {
        inActive: {
          name: "Potential P&L",
          content: "Profit that can be earned through this trade.",
        },
        active: {
          name: "Current P&L",
          content: "P & L of the live trade as per the entry price",
        },
        closed: { name: "Realized P&L", content: "P & L of the past trade." },
      },
      tradeBookmarkActive: false,
      securityBookmarkActive: false,
      // trade_bookmark_color: false,
      authenticated: isAuthenticated,
    };
  },
  computed: {
    formattedText() {
      // Regular expression to find URLs
      const urlRegex = /(https?:\/\/[^\s]+)/g;

      // Replace URLs with anchor tags
      const formatted = this.trade_card.reasoning.content.replace(
        urlRegex,
        function (url) {
          return '<a href="' + url + '" target="_blank">' + url + "</a>";
        }
      );

      return formatted;
    },
    is_same_user() {
      const user_id = localStorage.getItem("user_id");
      return Number(user_id) === Number(this.trade_data.posted_by_id);
    },
    isTradeUpcoming() {
      return this.trade_data.status == "Inactive";
    },
    isTradeLive() {
      return this.trade_data.status == "Active";
    },

    changeCurrentLabel() {
      switch (this.trade_data.status) {
        case "Inactive":
          return `${
            !this.$vuetify.breakpoint.xsOnly ? "Potential P&L" : "P. P&L"
          }`;
        case "Active":
          return `${
            !this.$vuetify.breakpoint.xsOnly ? "Current P&L" : "C. P&L"
          }`;
        default:
          return `${
            !this.$vuetify.breakpoint.xsOnly ? "Realized P&L" : "R. P&L"
          }`;
      }
    },
    is_posted_by_user() {
      const user_id = localStorage.getItem("profile_id");
      return Number(this.trade_data.posted_by) == Number(user_id);
    },
    changeCurrentToolTip() {
      switch (this.trade_data.status) {
        case "Inactive":
          return this.plToolTipContent.inActive;

        case "Active":
          return this.plToolTipContent.active;

        default:
          return this.plToolTipContent.closed;
      }
    },
    statusContent() {
      if (this.trade_card.status == "Active") {
        return "This is a live trade. Market entry was done on the Entry Price. Hold until Exit Price. Book profit/Cut loss on Target Price/Stop Loss";
      } else if (this.trade_card.status == "Inactive") {
        return "This is an upcoming trade and is not Live yet. Market entry to be done on the Entry Price.";
      } else if (this.trade_card.status == "Closed") {
        return "This is a past trade";
      } else {
        return "This trade is expired";
      }
    },
  },

  methods: {
    ...mapActions({
      snackBar: "snackBar/showSnack",
      toggleAddTradeModal: "addTrade/toggleTradeModal",
      toggleTradeModal: "tradeCardDialog/toggleModal",
    }),
    downloadReport(trade_data) {
      window.open(trade_data.report, "_blank");
    },
    readMoreEvents() {
      this.$logEvent("trade_detail_show_more");
      if (this.$vuetify.breakpoint.xsOnly) {
        this.$logEvent("mweb_trade_detail_show_more");
      }
    },
    deleteTrade() {
      // this.eventBus.$emit("delete-trade-card", {
      //   id: this.trade_data.id,
      //   flag: true,
      // });
      this.delete_data.id = this.trade_data.id;
      this.delete_data.flag = true;
    },
    addOrRemoveToFeatured(item) {
      this.featuredBtnLoader = true;
      const successHandler = (res) => {
        console.log(res);
        item.is_featured = !item.is_featured;
        this.trade_data = item;
        this.featuredBtnLoader = false;
        let msg;
        if (item.is_featured) {
          msg = "Trade added to featured sections successfully";
        } else {
          msg = "Trade removed to featured sections successfully";
        }
        this.snackBar({
          text: msg,
          color: "success",
          timeout: 4500,
        });
        this.eventBus.$emit("reload-trades");
        this.eventBus.$emit("refresh-trade-list");

        this.$logEvent("feature_trade_posted");
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$logEvent("mweb_feature_trade_posted");
        }
      };
      const failureHandler = () => {
        this.featuredBtnLoader = false;
      };
      let formData = {};
      formData["id"] = item.id;
      formData["is_featured"] = !item.is_featured;
      formData["request_type"] = "featured";
      Axios.request_PATCH(
        apiUrl.PATCH_TRADE_DETAIL,
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    removeLastName(value) {
      if (window.innerWidth <= "768" && value.split(" ").length > 1) {
        console.log(value.split(" ").length);
        return `${value.split(" ", 1)[0]} ${value
          .split(" ", -1)
          .pop()
          .substring(0, 1)}.`;
      } else {
        return value;
      }
    },
    exitTradeHandler(trade) {
      if (trade.is_real) {
        this.exitRealTrade(trade, "EXIT");
      } else {
        this.exitTrade(trade.id);
      }
    },
    exitRealTrade(item, tradeActions) {
      // console.log(item, "exit");
      let headers = {};
      let params = {};
      params["trade_id"] = item.id;
      params["order_type"] = item.order_type;
      params["trade_action"] = tradeActions;
      // params["auth_id"] = '';
      let config = {
        headers: headers,
        params: params,
      };
      this.tempAxios
        .post(apiUrl.EXIT_ORDER, {}, config)
        .then((res) => {
          this.triggerTransactionFLowSmallCase(
            res.data.resp.transactionId,
            res.data.auth_token,
            item.id,
            tradeActions
          );
          this.exitTrade(item.id);
        })
        .catch((err) => {
          console.log(err);
          this.snackBar({
            text: err,
            color: "success",
            timeout: 4500,
          });
        });
    },
    triggerTransactionFLowSmallCase(
      transactionID,
      authToken,
      trade_id,
      tradeActions
    ) {
      console.log(transactionID, authToken, trade_id);
      // const self = this;
      const gatewayInstance = new window.scDK({
        gateway: "covesto",
        smallcaseAuthToken: authToken,
        config: {
          amo: true,
        },
      });

      gatewayInstance
        .triggerTransaction({
          // ! Use valid transactionId here
          transactionId: transactionID,
        })
        .then((txnResponse) => {
          // console.log(txnResponse);
          commonFunctions.decode_smallcase_authtoken_and_send(
            txnResponse,
            trade_id,
            tradeActions
          );
          // self.updateRealTrade(txnResponse, trade_id);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    exitTrade(id) {
      this.exitBtnLoader = true;
      const successHandler = (res) => {
        this.trade_data = res.data.trade_detail;
        // console.log(res);
        // this.$emit("exitReload");
        this.exitBtnLoader = false;

        this.$logEvent("exit_trade_successfully");
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$logEvent("mweb_exit_trade_successfully");
        }
        // this.is_trade_exit = true;
        this.trade_data.trade_exit_type = true;
        // location.reload();
        this.trade_card = { ...this.trade_card, status: "Closed" };
      };
      const failureHandler = () => {
        this.exitBtnLoader = false;
      };
      let formData = {};
      formData["id"] = id;
      Axios.request_POST(
        "api/trade/exit-trade",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    modifyTrade(id) {
      this.toggleAddTradeModal({
        show: true,
        type: "edit",
        id: id,
      });
    },
    viewTrade(event) {
      this.$logEvent(event);
      // console.log("event", event);
      // this.$emit("openTrade", this.trade_detail.id);
    },
    copyTrade(item) {
      if (!this.authenticated()) {
        this.snackBar({
          text: "Login required for following action",
          color: "success",
          timeout: 4500,
        });
        this.$router.push({ name: "login" });
        return false;
      }
      if (item.status === "Closed") {
        // this.toggleTradeModal({
        //   show: true,
        //   type: "copy",
        //   id: item.id,
        // });
        this.toggleAddTradeModal({
          show: true,
          type: "copy",
          id: item.id,
        });
      } else {
        // this.toggleTradeModal({
        //   show: true,
        //   type: "copy",
        //   copyDetail: item,
        //   id: item.id,
        // });
        this.toggleAddTradeModal({
          show: true,
          type: "copy",
          id: item.id,
          copyDetail: item,
        });
      }
    },
    closeComment(value) {
      this.comment = value;
    },
    countComment(value) {
      console.log(value);
      this.trade_card.comments_count = value;
    },
    openComment() {
      if (this.$vuetify.breakpoint.xsOnly) {
        this.$logEvent("trade_detail_comment");
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$logEvent("mweb_trade_detail_comment");
        }
      }
      if (this.comment == null) {
        this.comment = 0;
      } else {
        this.comment = null;
      }
    },
    getCharacter(value) {
      return value
        .replace(/\s*(\S)\S*/g, "$1")
        .toUpperCase()
        .slice(0, 2);
    },
    getTime(value) {
      return dayjs(value).format("h:mm A D MMM");
    },
    removeNegativeSign(value) {
      if (value?.slice(0, 1) == "-") {
        return `- ₹${value?.slice(1)}`;
      } else {
        return "₹" + value;
      }
    },
    tradeCardStatus(value) {
      if (value == "Inactive") {
        return (value = "Upcoming");
      } else if (value == "Active") {
        return (value = "Live");
      } else {
        return value;
      }
    },
    getWatchlistTabs(type) {
      if (type == "trade") {
        this.bookmark_loading = true;
      } else {
        this.security_bookmark_loading = true;
      }
      const successHandler = (res) => {
        this.watchlistTabs = res.data;
        this.bookmark_loading = false;
        this.security_bookmark_loading = false;
        this.$logEvent("trade_card_watchlist");
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$logEvent("mweb_trade_card_watchlist");
        }
      };
      const failureHandler = () => {};
      let formData = {};
      formData["category__watchlist_type"] = type;
      formData["profile__user__id"] = commonFunctions.getUserId();
      Axios.request_GET(
        "watchlist/detail/",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    addOrRemoveWatchlist(item, type, follower) {
      // console.log(follower);
      // if (type == "trade" || type == "stock") {
      //   this.bookmark_loading = true;
      // } else {
      //   this.security_bookmark_loading = true;
      // }

      if (!commonFunctions.IsAuth()) {
        this.$router.push({ name: "login" });
        return;
      }
      const successHandler = (res) => {
        console.log(res);

        // this.bookmark_loading = false;
        // this.security_bookmark_loading = false;

        if (type == "trade") {
          follower.is_follower = true;
          this.tradeBookmarkActive = true;
        } else {
          follower.is_follower_security = true;
          this.securityBookmarkActive = true;
        }
        // this.eventBus.$emit("watchlist-updated");

        this.$logEvent("trade_card_watchlist");
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$logEvent("mweb_trade_card_watchlist");
        }
      };
      const failureHandler = () => {
        this.bookmark_loading = false;
        this.security_bookmark_loading = false;
      };
      let formData = {};

      // params["follower_id"] = commonFunctions.getUserId();
      if (type == "trade") {
        formData["watchlist"] = item.id;
        formData["trade"] = this.trade_data.id;
      } else {
        formData["watchlist"] = item.id;
        formData["stock"] = this.trade_data.security;
      }

      Axios.request_POST(
        "watchlist/items/",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    shareTrade(id, posted_by, type, trade_name, user_id, isEquity) {
      this.shareCoinTrade();
      const title = "Covesto";
      const isFnotrade = isEquity ? false : true;
      const text = `Hello, ${posted_by} has shared a trade recommendation on Covesto. ${type} ${trade_name}
            To know more details and get live updates, follow the trade at `;
      // const url = `https://covesto.in/trade/${id}/${trade_name}`;

      const url = `${location.origin}/profile/${user_id}/${posted_by}/?fotrade=${isFnotrade}&trade_id=${id}&trade_name=${trade_name}`;
      // console.log(u_url);

      helper.shareLink(url, text, title);

      this.$logEvent("trade_card_share");
      if (this.$vuetify.breakpoint.xsOnly) {
        this.$logEvent("mweb_trade_card_share");
      }
    },
    shareCoinTrade() {
      const onSuccess = () => {};
      const onFailure = () => {};
      newAxios("get", apiUrl.POST_SHARE_TRADE, {
        onSuccess,
        onFailure,
        isTokenRequired: true,
      });
    },
    goToProfile(e, name) {
      console.log("lick", e.target.className.split(" ")[0], name);
      if (e.target.className.split(" ")[0] === "card-user-name") {
        // console.log(target);
        if (this.is_same_user) {
          this.$router.push({
            name: "ProfilePage",
          });
        } else {
          this.$router.push({
            name: "OthersProfilePage",
            params: { id: this.trade_card.posted_by_id, name: name },
          });
        }
      }
      // }
    },
    goToGroup(id, group) {
      this.$router.push({
        name: group.group_type == "Premium" ? "premiumGroup" : "GroupDetails",
        params: {
          id: id,
        },
      });
    },
    shareLink(refValue) {
      let url = location.href;
      let text = `Hey check out ${this.trade_card.security_symbol} stock on Covesto Social Trading Platform.`;
      let title = "Stock Detail";
      helper.shareSsAndLink(refValue, url, text, title);
    },
    routeToSearchPage(item) {
      this.$router.push({
        name: "Search",
        params: { query: `${item.security_name}-${item.security_exchange}` },
        query: { tab: 0 },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.tooltip {
  background: #f7faff;
  opacity: 1 !important;
  // text-align: center;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px !important;
}
.tooltip-text {
  color: #111111 !important;
}
.manual-exit {
  margin-left: 6px;
  position: absolute;
  padding: 5px 6px;
  border-radius: 1.25rem;
  background: rgba(235, 87, 87, 0.16);
  color: #eb5757;
  // text-align: center;
  font-size: 0.6875rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.02063rem;
}
.trade-origin {
  color: rgba(51, 51, 51, 0.6);
  text-align: center;
  font-family: Avenir;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  text-transform: capitalize;
}
.origin-name {
  color: var(--Primary, #2d8cff);
  text-align: center;
  font-family: Avenir;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  text-transform: capitalize;
}
::v-deep.security-bookmark {
  height: 32px;
  width: 32px;
}
::v-deep.tooltip-status .v-tooltip__content {
  // background-color: #fff !important;
}
.security-bookmark {
  margin-top: -6px;
}
.virtual-trade-color {
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(90deg, #3b3c5d 0%, #7277f1 100%);

  div {
    color: #fff;
    text-align: center;
    font-size: 0.6875rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.02063rem;
  }
}
.real-trade-color {
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(90deg, #0b2c24 0%, #247a4d 100%);

  div {
    color: #fff;
    text-align: center;
    font-size: 0.6875rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.02063rem;
  }
}
.tooltip-status {
  // background-color: #fff;
  // opacity: 1 !important;
  // border: 1px solid #000;
}
.tooltip-content-wrapper {
  // background: #fff;
  // border: 1px solid #000;
  // box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px,
  //   rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;
  // padding: 15px;
  // padding-left: 0;
}
::v-deep.comment-panel > .v-expansion-panel-content__wrap {
  padding: 0 !important;
}

.live-current-price-label {
  color: rgba(51, 51, 51, 0.84);
  text-align: right;
  font-family: Avenir;
  font-size: 0.995rem;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.live-current-price {
  color: #333;
  font-family: Avenir;
  font-size: 1rem;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.live-price-percentage {
  color: var(--Red, #eb5757);
  font-family: Avenir;
  font-size: 0.7875rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1.25rem; /* 181.818% */
}
.live-current-percentage {
  color: var(--Red, #eb5757);
  font-family: Avenir;
  font-size: 1rem;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}
.negative-live-price {
  color: #eb5757;
}
.positive-live-price {
  color: rgb(51, 193, 110);
}
.negative-currentPL-price {
  color: #eb5757;
}
.positive-currentPL-price {
  color: rgb(51, 193, 110);
}
.card-user-name {
  cursor: pointer;
  color: #000;
  font-size: 0.9125rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.brand-name {
  color: #333;
  font-family: Avenir;
  font-size: 1.155rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1.5rem; /* 133.333% */
}
.brand-subtitle {
  word-break: normal;
  color: #888;
  font-family: Avenir;
  font-size: 0.725rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.card-actions {
  padding: 14px 8px 16px 16px;
}
.brand-logo {
  width: 2.6rem;
  height: 2.6rem;
}
.brand-bg {
  // height: rem;
  // width: 4rem;
  padding: 8px;
  border-radius: 10px;
  // background-color: #f5f5f5;
  border-radius: 0.375rem;
  border: 1.6px solid #b8b8b8;
}
.trade-btn {
  text-transform: capitalize;
  width: 10rem;
}
.other-btn {
  text-transform: capitalize;
  border-radius: 5px;
}
.card-live > span:not(:nth-of-type(1)):nth-of-type(n) {
  color: #555;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  text-transform: uppercase;
}
// .Upcoming {
//   padding: 0.18rem 0.6rem;
//   display: flex;
//   align-items: center;
//   height: fit-content;
//   border-radius: 1.25rem;
//   background: rgba(45, 140, 255, 0.16);
//   width: fit-content;
//   div {
//     color: #2d8cff;
//     text-align: center;
//     font-size: 0.75rem;
//     font-style: normal;
//     font-weight: 800;
//     line-height: normal;
//     letter-spacing: -0.0225rem;
//   }
// }
.not-status {
  color: rgba(51, 51, 51, 0.6);
  text-align: left;
  margin-left: 0.6rem;
  // text-align: center;
  font-family: Avenir;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  letter-spacing: -0.0225rem;
}

.Closed {
  padding: 0.18rem 0.6rem;
  padding-right: 0.75rem;
  width: fit-content;
  display: flex;
  align-items: center;
  height: fit-content;
  border-radius: 1.25rem;
  background: rgba(235, 87, 87, 0.16);
  div {
    color: #eb5757;
    text-align: center;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    letter-spacing: -0.0225rem;
  }
}
.Live {
  width: fit-content;
  padding: 0.18rem 0.6rem;
  padding-right: 0.75rem;
  display: flex;
  align-items: center;
  height: fit-content;
  border-radius: 1.25rem;
  background: rgba(39, 174, 96, 0.16);
  div {
    color: #27ae60;
    text-align: center;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    letter-spacing: -0.0225rem;
  }
}
.show_more {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 18px;
  /* identical to box height */

  color: #2d8cff;
  cursor: pointer;
}
.time > span {
  color: rgba(51, 51, 51, 0.87);
  text-align: center;
  font-size: 0.5625rem !important;
  font-style: normal;
  font-weight: 800;
  line-height: 0ch;
  letter-spacing: -0.02063rem;

  // span {
  //   color: rgba(51, 51, 51, 0.87);
  //   font-size: 0.5625rem;
  //   font-style: normal;
  //   font-weight: 800;
  //   line-height: normal;
  //   letter-spacing: -0.01688rem;
  // }
}

.brand-txt {
  color: #333;
  font-size: 0.8125rem;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
}

.card-live-txt {
  // color: #2d8cff;
  text-align: center;
  font-family: Avenir;
  font-size: 1rem;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  text-transform: uppercase;
}
.v-btn:not(.v-btn--round).v-size--default.share {
  min-width: 0px;
  padding: 0 8px;
}
.v-btn:not(.v-btn--round).v-size--default.message {
  min-width: 0px;
  padding: 0 8px;
}
.action-name {
  font-size: 14px;
  color: #7f7f7f;
}
.by-name {
  font-size: 12px;
  color: #69a0b6;
}
.dots-group {
  width: 2.55394rem;
  height: 0.41194rem;
}
.for-title {
  // display: flex;
  // flex-direction: column;
  // justify-content: space-between;
}
.card-titles {
  display: flex;
  flex-direction: column;
  justify-content: center;
  // width: 280px;
}
@media only screen and (max-width: 959px) {
  .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
    display: flex !important;
  }
}
.users-img {
  max-height: 2.625rem;
  max-width: 2.625rem;
}

.user-image {
  overflow: hidden;
  border-radius: 50%;
  object-fit: contain;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.625rem !important;
  width: 2.625rem !important;
}

.v-card {
  box-shadow: none !important;
}

@media only screen and (max-width: 768px) {
  .card-live {
    // display: flex;
    // align-items: center;
    // margin: 6px 0;
  }
  ::v-deep.security-bookmark {
    height: 20px;
    width: 20px;
    margin-top: -5px;
  }
  .v-btn:not(.v-btn--round).v-size--small {
    min-width: 26px !important;
    padding: 0 !important;
  }
  .for-title {
    align-items: self-start;
  }
  .brand-bg {
    height: 2.3rem;
    width: 2.3rem;
    padding: 2.6px;
    display: flex;
  }
  .brand-logo {
    width: unset !important;
    height: unset !important;
  }
  .brand-name {
    font-size: 0.875rem;
    font-style: normal;
    line-height: 0.875rem; /* 100% */
  }
  .brand-subtitle {
    font-size: 0.5625rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    max-width: 173px;
  }
  .card-live-txt {
    font-size: 0.735rem;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    // text-transform: uppercase;
  }
  .card-live > span:not(:nth-of-type(1)):nth-of-type(n) {
    font-size: 0.63rem;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
  }
  .Closed {
    color: #eb5757 !important;
    display: block;
    text-align: center;
    font-family: Avenir;
    height: none;
    width: initial;
    font-size: 0.625rem;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    letter-spacing: -0.01875rem;
    background: none;
    padding: 0;
    // margin-top: 8px;
  }
  .Upcoming {
    color: #2d8cff;
    text-align: center;
    font-family: Avenir;
    font-size: 0.625rem;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    letter-spacing: -0.01875rem;
    background: none;
    padding: 0;
    // margin-top: 8px;
  }
  .Live {
    color: #27ae60;
    text-align: center;
    font-family: Avenir;
    font-size: 0.625rem;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    letter-spacing: -0.01875rem;
    background: none;
    padding: 0;
    // margin-top: 8px;
    background: none;
    padding: 0;
    // margin-top: 8px;
  }
  .reasoning-content {
    font-size: 0.625rem;
    line-height: normal;
  }
  .card-user-name {
    color: #000;
    font-size: 0.525rem;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
  }
  .dots-group {
    width: 1.48rem;
    height: 0.25rem;
  }
  .user-image {
    width: 1.625rem !important;
    height: 1.625rem !important;
    min-width: unset !important;

    div {
      font-size: 10px;
    }
  }
  .users-img {
    max-height: 1.625rem !important;
    max-width: 1.625rem;
  }

  .trade-btn {
    height: 28px !important;
    width: 5.125rem;
  }
  .other-btn {
    height: 28px !important;
    border-radius: 5px;
    width: 6rem;
    font-size: 12px;
  }
  .show_more {
    font-size: 0.625rem;
    line-height: normal;
    text-decoration-line: underline;
  }

  .live-current-price {
    font-size: 11.3px !important;
    font-style: normal;
    font-weight: 800;
    line-height: normal !important;
  }
  .live-current-price-label {
    font-size: 0.745rem;
    // width: 52px;
    font-style: normal;
    font-weight: 800;
    line-height: normal;
    text-align: left;
  }
  .live-current-percentage {
    font-size: 11.3px !important;
    line-height: normal !important;
  }
  .live-price-percentage {
    font-size: 9.5px !important;
    line-height: normal !important;
  }
  .time {
    line-height: 1.5ch;
  }
  .manual-exit {
    font-size: 0.5575rem;
    padding: 3px 5px;
  }
}
</style>
